<template>
  <div class="max-w-screen-sm lg:max-w-content-sm mx-auto my-10 lg:my-15">
    <div v-if="loading" class>
      <p class="text-center text-18 md:text-20">Loading Team...</p>
    </div>
    <div class="p-2.5 md:px-5 xl:px-0 md:py-5 md:grid md:grid-cols-3 lg:grid-cols-4 gap-2">
      <div v-for="(teamMember, index) in teamMembers" :key="index" class="w-full mb-2.5 md:mb-0">
        <team-member-preview :team-member="teamMember"></team-member-preview>
      </div>
    </div>
    <div v-if="error" class="py-5 md:py-15 text-center mx-auto max-w-screen-sm lg:max-w-content-sm">
      <p class="text-18 md:text-20">
        {{ error }}
      </p>
      <button class="button block mx-auto min-w-280 md:min-w-360" @click.prevent="getTeamMembers">
        Try again
      </button>
    </div>

    <portal to="modals" v-if="$store.state.modals.teamMemberModal">
      <modal-component
        :show="true"
        @close="closeTeamMemberModal"
        container-classes="max-w-content-xl mt-8 md:mt-0"
        wrapper-classes="flex"
      >
        <team-member-details :id="$store.state.modals.teamMemberModal"></team-member-details>
      </modal-component>
    </portal>
  </div>
</template>

<script>
import Route from '../src/Route';
import TeamMemberPreview from './TeamMemberPreview.vue';
import TeamMemberDetails from './TeamMemberDetails.vue';
import ModalComponent from './ModalComponent.vue';

export default {
  components: { TeamMemberPreview, TeamMemberDetails, ModalComponent },

  data() {
    return {
      teamMembers: [],
      loading: false,
      error: null,
    };
  },

  created() {
    this.getTeamMembers();
  },

  methods: {
    getTeamMembers() {
      this.loading = true;
      this.error = null;

      axios
        .get(Route('json.team-members.index'))
        .then((response) => {
          if (response.status === 200) {
            this.teamMembers = response.data.team_members;
          } else {
            throw 'There was a problem.';
          }
        })
        .catch((error) => {
          this.error = 'Sorry there was a problem loading team members.';
        })
        .then(() => {
          this.loading = false;
        });
    },

    closeTeamMemberModal() {
      this.$store.commit('modals/SET_TEAM_MEMBER_MODAL', null);
    },
  },
};
</script>
